import styled, { css } from 'styled-components';

export enum INPUT_SIZE {
	SMALL = 'small',
	REGULAR = 'regular',
	LARGE = 'large'
}

export type InputProps = {
	$inputSize: Lowercase<keyof typeof INPUT_SIZE>;
	$hasSuffix?: boolean;
	$hasPrefix?: boolean;
};

const sizeMixin = (size: InputProps['$inputSize']) => {
	if (size === INPUT_SIZE.SMALL) {
		return css`
			height: 36px;
			font-size: 14px;

			&::placeholder {
				font-size: 14px;
			}
		`;
	} else if (size === INPUT_SIZE.LARGE) {
		return css`
			height: 48px;
			font-size: 18px;

			&::placeholder {
				font-size: 18px;
			}

			${Label} {
				font-size: 16px;
			}
		`;
	} else {
		return css`
			height: 42px;
			font-size: 16px;

			&::placeholder {
				font-size: 16px;
			}
		`;
	}
};

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
`;

export const Label = styled.label<{ $isError?: boolean }>`
	font-size: 14px;
	font-weight: 600;
	line-height: 18px;
	color: ${({ theme, $isError }) => ($isError ? theme.colors.text.error : theme.colors.text.alwaysWhite)};
	margin-bottom: 8px;

	& > span {
		color: ${({ theme }) => theme.colors.text.error};
	}
`;

export const InputWrapper = styled.div`
	position: relative;
	width: 100%;
`;

export const InputIcon = styled.div<{ $position: 'start' | 'end' }>`
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
	left: ${({ $position }) => ($position === 'start' ? '12px' : 'auto')};
	right: ${({ $position }) => ($position === 'end' ? '12px' : 'auto')};
	width: 20px;
	height: 20px;

	svg {
		fill: ${({ theme }) => theme.colors.text.alwaysWhite};
		opacity: 0.5;
		width: 100%;
		height: 100%;
		cursor: ${({ $position }) => ($position === 'end' ? 'pointer' : 'default')};
	}
`;

export const InputStyled = styled.input<InputProps>`
	background: ${({ theme }) => theme.colors.transparent.light10};
	border: 1px solid ${({ theme }) => theme.colors.transparent.light10};
	height: 42px;
	border-radius: 12px;
	padding: 8px 0;
	padding-left: ${({ $hasPrefix }) => ($hasPrefix ? '38px' : '12px')};
	padding-right: ${({ $hasSuffix }) => ($hasSuffix ? '38px' : '12px')};
	width: 100%;
	font-weight: 400;
	color: ${({ theme }) => theme.colors.text.alwaysWhite};

	&:disabled {
		pointer-events: none;
	}

	&::placeholder {
		font-weight: 400;
		color: ${({ theme }) => theme.colors.text.alwaysWhite};
		opacity: 0.5;
	}

	&:focus,
	&:active {
		border-color: ${({ theme }) => theme.colors.transparent.light60};
	}

	${({ $inputSize }) => sizeMixin($inputSize)}
`;
